<template>
  <div>
    <div>
      <b-alert
        variant="success"
        show
        v-for="x in notifList"
        :key="x.id"
        dismissible
        @dismissed="dismisAlert(x.id)"
      >
        ({{ x.desc }})
        <div>{{ x.title }}</div>
      </b-alert>
    </div>
    <StepRegister v-if="uc < 1" class="mb-5" :className="className" />
    <BI v-bind:id="1"></BI>
    <div class="text-center"></div>
  </div>
</template>
<style>
.grid-stack-item-content {
  background-color: red;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import BI from "../../components/BI";
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import StepRegister from "../User/StepRegister.vue";

export default {
  name: "dashboard",
  data() {
    return {
      grid: null,
      notifList: [],
      uc: 1,
      className: null,
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "صفحه ی اصلی" }]);
    if (this.$route.query.from == "new" && localStorage.getItem("singup")==null ) {
      localStorage.setItem("singup",true);
      this.$makeToast(
              "success",
              "ثبت نام موفق",
              `ثبت نام اولیه شما با موفقیت انجام شد٬لطفا مراحل زیر را دنبال کنید.`,
              8000,
              'singup',
            );
    }
    var pusher = new Pusher("ac8a3144c04cfc84edee", {
      cluster: "eu",
    });
    this.$route.query.from === "NewUserFromEnamad"
      ? this.$makeToast(
          "success",
          "ایجاد کاربری",
          `کاربر گرامی،درخواست درگاه شما باموفقیت ثبت گردید.پس از بررسی توسط کارشناسان موارد بصورت تیکت و ایمیل اطلاع رسانی خواهد شد.`,
          7000
        )
      : "";
    var channel = pusher.subscribe("my-channel");
    channel.bind("my-event", function (data) {});
    this.getNotif();
    this.uc = 1;
    httpHelper.getData("paymentgateways").then((response) => {
      if (response.success === true) {
        this.uc = response.result.length;
      } else {
        this.uc = 0;
      }
    });
    if (this.$route.query.from == "new") {
      this.className = "information";
    }
    if (this.$route.query.from == "information") {
      this.className = "authentication";
    } else if (this.$route.query.from == "authentication") {
      this.className = "bussines";
    }
  },
  components: {
    BI,
    StepRegister,
  },
  methods: {
    getNotif() {
      httpHelper.getData("message?p=false").then((res) => {
        this.notifList = res.result.map((element) => {
          return {
            id: element.id,
            desc: persianDate.getDate(element.created_at),
            title: element.description,
            color: "danger",
            icon: "flaticon2-line-chart text-success",
          };
        });
      });
    },
    dismisAlert(id) {
      httpHelper.postData("message", { id: id }).then((res) => {
        this.getNotif();
      });
    },
  },
};
</script>
